import {Component, OnInit} from '@angular/core';
import {AuthAccessProvider} from '../core/core.auth';
import {MessageProvider} from '../service/message.service';
import {UserService} from '../service/user.service';
import {Router} from '@angular/router';
import {UserContext, BaseComponent} from '../core/core.component';

@Component({
  selector: 'app-checkhr',
  templateUrl: './checkhr.component.html',
  styleUrls: ['./checkhr.component.css'],
})
export class CheckhrComponent extends BaseComponent implements OnInit {

  userContext: UserContext;
  isUserAdmin = false;

  displayCheckhrDefs = 'active';
  displayCheckhrUsers = '';

  constructor(protected authAccess: AuthAccessProvider,
    protected router: Router,
    protected messageProvider: MessageProvider,
    private userService: UserService) {
    super(authAccess, router, messageProvider);
    this.messageProvider.clearAll();
  }

  ngOnInit() {
    this.userContext = this.authAccess.getUserContext();
    if (this.userContext == null) {
      this.authAccess.invalidate();
    } else {
      this.userService.isUserAdmin(this.userContext.srmToken).subscribe(
        result => {
          this.isUserAdmin = result.message === 'true';
        },
        error => {
          this.handleError(error);
        });
    }
  }

  display(section: string) {
    this.displayCheckhrDefs = '';
    this.displayCheckhrUsers = '';
    if (section === 'definitions') {
      this.displayCheckhrDefs = 'active';
    } else if (section === 'users') {
      this.displayCheckhrUsers = 'active';
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/checkhr/checkhr.component.ts